import { render, staticRenderFns } from "./OrgHomeStatsNewCases.vue?vue&type=template&id=26d08e14&"
import script from "./OrgHomeStatsNewCases.vue?vue&type=script&lang=js&"
export * from "./OrgHomeStatsNewCases.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeStatsNewCases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports